import React from 'react';
import QRCodeSVG from "qrcode.react";
import {useParams} from "react-router-dom";

function QrSimms() {
    const list =JSON.parse(localStorage.getItem('qrList'))
    const FE_URL = import.meta.env.VITE_FE_URL;
    const origin = window.location.origin;
    console.log(list)
    return (
        <div className={"w-full h-full"}>
            {list.map(each=>
                <div className={"qr-each w-full"}>
                    <div className={"p-[10px] w-[100px]"}>
                        <QRCodeSVG value={`${origin}/asset/${each.id}`} size={80}/>
                    </div>
                    <div className={"w-full"}>
                        <table className={"qr-table"}>
                            <tr>
                                <th>자산명</th>
                                <td>{each.assetName}</td>
                                <th>자산코드</th>
                                <td>{each.assetCode}</td>
                            </tr>
                            <tr>
                                <th>자산그룹</th>
                                <td>{each.groupName}</td>
                                <th>업무그룹</th>
                                <td>{each.taskName}</td>
                            </tr>
                            <tr>
                                <th>운영담당자</th>
                                <td>
                                    {each.operator && each.operator.length > 0 ? (
                                        <>
                                            {each.operator[0].name}
                                            {each.operator.length > 1 && ` 외 ${each.operator.length - 1}명`}
                                        </>
                                    ) : (
                                        ''
                                    )}
                                </td>
                                <th>자산사용자</th>
                                <td>
                                    {each.handler && each.handler.length > 0 ? (
                                        <>
                                            {each.handler[0].name}
                                            {each.handler.length > 1 && ` 외 ${each.handler.length - 1}명`}
                                        </>
                                    ) : (
                                        ''
                                    )}
                                </td>
                            </tr>
                        </table>
                    </div>

                </div>
            )}
        </div>
    );
}

export default QrSimms;